import { IApplicationState } from '../../types/redux';

/**
 * Выбирает статьи на Главной
 */
export const selectMainArticles = ({ mainArticles, settings: { initialPageNumber } }: IApplicationState) => {
  if (initialPageNumber === 1) {
    return mainArticles.items.slice(1);
  }

  return mainArticles.items;
};
